var mapObject;

function showlog(o) {
    console.log(o);
}

function GetItemByFieldName(myValue, fieldName, myArray) {
    var result = $.grep(myArray, function (e) { return e[fieldName] == myValue; });
    return result;
}

function loadMapScript() {
    var apimap = "//maps.googleapis.com/maps/api/js?";

    var isloaded = false;
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src.includes(apimap))
            isloaded = true;
    }

    if (!isloaded) {
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = apimap +
            '&key=' + GOOGLE_MAP_KEY
        document.body.appendChild(script);

        script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//www.bing.com/api/maps/mapcontrol?' +
            '&key=' + BING_MAP_KEY
        document.body.appendChild(script);
    }
}

//GetItemByFieldName works not correctly for the case qualificationList qcParentId=0
//use GetItemByFieldNameV2
function GetItemByFieldNameV2(dataList, fieldName, value) {
    var result = [];
    for (var i = 0; i < dataList.length; i++) {
        if (dataList[i][fieldName] == value) {
            result.push(dataList[i]);
        }
    }
    return result;
}

var tryShowMap = 0;
function ShowGmapsOnSideBar(x, y, mapObject, mapObjectId, scrollInMap, showMapControl) {
    if (typeof google != 'undefined' && document.getElementById(mapObjectId) != null) {
        var latlng = new google.maps.LatLng(48.858234, 2.293655);
        var myZoom = 1;
        if (x != undefined && y != undefined) {
            latlng = new google.maps.LatLng(x, y);
            myZoom = 16;
        }

        if (!mapObject) {
            mapObject = new google.maps.Map(document.getElementById(mapObjectId), {
                zoom: myZoom,
                center: latlng,
                scrollwheel: scrollInMap,
                mapTypeControl: showMapControl
            });

            mapObject.myCurrentCenter = latlng;
            mapObject.recenterMyMap = true;
            mapObject.recenterMyMapFullScreen = true;

            google.maps.event.addListener(mapObject, 'idle', function () {
                gmapDiv = $('#' + mapObjectId + ' div.gm-style');
                if (gmapDiv.width() === window.innerWidth && mapObject.recenterMyMapFullScreen) {
                    mapObject.setCenter(mapObject.myCurrentCenter);
                    mapObject.recenterMyMapFullScreen = false;
                    mapObject.recenterMyMap = true;
                }
                if (gmapDiv.width() != window.innerWidth && mapObject.recenterMyMap) {
                    mapObject.setCenter(mapObject.myCurrentCenter);
                    mapObject.recenterMyMapFullScreen = true;
                    mapObject.recenterMyMap = false;
                }
            });
            new google.maps.Marker({
                position: latlng,
                map: mapObject
            });
        }
    } else {
        if (tryShowMap < 50) {
            setTimeout(function () {
                ShowGmapsOnSideBar(x, y, mapObject, mapObjectId, scrollInMap, showMapControl);
            }, 300);
            tryShowMap++;
        } else {
            console.log("Cannot load map because google.maps is undefined");
        }
    }
}

String.prototype.replaceAll = function (str1, str2, ignore) {
    return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
}

String.prototype.includes = function (search, start) {
    'use strict';
    if (typeof start !== 'number') {
        start = 0;
    }

    if (start + search.length > this.length) {
        return false;
    } else {
        return this.indexOf(search, start) !== -1;
    }
};

function GetSelectedIdList(dataList, fieldName) {
    var result = [];
    for (var i = 0; i < dataList.length; i++) {
        if (dataList[i].selected) {
            result.push(dataList[i][fieldName]);
        }
    }
    return result;
}

function ValidatePassword(pass1, pass2, errorMessage1, errorMessage2) {
    var result = {};
    result.HasError = false;
    if (pass1 != pass2) {
        result.HasError = true;
        result.ErrorMessage = errorMessage1;//'Les mots de passe ne correspondent pas. Veuillez réessayer.';
    }
    else {
        if (pass1.length < 8) {
            result.HasError = true;
            result.ErrorMessage = errorMessage2; //'Votre mot de passe doit avoir au moins de 8 charactères. Veuillez réessayer.';
        }
    }
    return result;
}

var getPlainWordCount = function (textWithHTML) {
    var plainText = '';
    if (textWithHTML != undefined) {
        plainText = textWithHTML.replace(/<\/?[^>]+(>|$)/g, "").replaceAll('&nbsp;', ' ');
    }
    var s = plainText ? plainText.split(/\s+/) : 0;
    return s.length ? s.length : 0;
};

var getPlainCharCount = function (textWithHTML) {
    if (textWithHTML != undefined) {
        plainText = textWithHTML.replace(/<\/?[^>]+(>|$)/g, "").replaceAll('&nbsp;', ' ');
        return plainText.length;
    }
}

//For Drag and Drop fiw width & width
var fixHelper = function (e, ui) {
    ui.children().each(function () {
        $(this).width($(this).width());
    });
    return ui;
}

var CountActiveItems = function (dataList) {
    var count = 0;
    if (dataList) {
        dataList.forEach(function (value) {
            if (value.actif) {
                count++;
            }
        });
    }
    return count;
};

//Add format function like in C#, {0}, {1}
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}